export const CONTRACT_GROUP_STATUS = {
  VOID: 'Voided'
}

export const MAX_EMPLOYEE_ELIGIBILITY_AGE = 120;
